import ProductsServices from "@/services/Product";

export default async function editProductRecipe(prc)  {

    var material = await ProductsServices.getMaterials();

      return {
        name: "Modifiko produktin e perbere",
        submit: {
          label: "Modifiko",
          action: "submitProductRecipe",
        },
        fields: [
          [
            {
                value: prc.material_id,
                name: "material_id",
                label: "Materiali",
                type: "select-field",
                options: material,
                style: "flex-grow: 0.4",
                required: true,
                required_text: "Kjo fushe eshte e detyrueshme",
            },
            {
              value: prc.quantity,
              name: "quantity",
              label: "Sasia",
              type: "number-field",
              style: "flex-grow: 0.4",
              required: true,
              required_text: "Kjo fushe eshte e detyrueshme",
            },
          ],
        ],
      };
    }
  
  